const getSubsector = (initiative, sectors) => {
    let subsector = '<not set>';

    initiative?.impact?.find(
        (impact) => {
            if (impact?.subsector) {
                const subsectorObj = sectors?.find(s => s._id === impact.subsector);

                if (subsectorObj?.subsectorName === 'Cereals') {
                    subsector = 'Cereals';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Pulses') {
                    subsector = 'Pulses';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Oilseeds') {
                    subsector = 'Oilseeds';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Vegetables') {
                    subsector = 'Vegetables';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Fruits') {
                    subsector = 'Fruits';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Flower') {
                    subsector = 'Flower';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Spices') {
                    subsector = 'Spices';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Forestry') {
                    subsector = 'Forestry';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Sugar cane') {
                    subsector = 'Sugar cane';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Cotton') {
                    subsector = 'Cotton';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Sisal') {
                    subsector = 'Sisal';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Coffee') {
                    subsector = 'Coffee';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Tea') {
                    subsector = 'Tea';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Tobacco') {
                    subsector = 'Tobacco';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Rubber') {
                    subsector = 'Rubber';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Bamboo Tree') {
                    subsector = 'Bamboo Tree';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other cops') {
                    subsector = 'Other cops';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Dairy Farming') {
                    subsector = 'Dairy Farming';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Poultry') {
                    subsector = 'Poultry';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Fattening') {
                    subsector = 'Fattening';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Fishing') {
                    subsector = 'Fishing';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Apiculture( Beehives)') {
                    subsector = 'Apiculture( Beehives)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other animal Husbandry') {
                    subsector = 'Other animal Husbandry';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Processed Dairy Products') {
                    subsector = 'Processed Dairy Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Processed Fruits and Vegetables') {
                    subsector = 'Processed Fruits and Vegetables';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Sugar and Sugar Confectionery') {
                    subsector = 'Sugar and Sugar Confectionery';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Beverages') {
                    subsector = 'Beverages';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Flour, Macaroni, Spaghetti and Biscuits') {
                    subsector = 'Flour, Macaroni, Spaghetti and Biscuits';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Edible Oil') {
                    subsector = 'Edible Oil';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Cigarettes') {
                    subsector = 'Cigarettes';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Textiles') {
                    subsector = 'Textiles';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Paper and Paper Products') {
                    subsector = 'Paper and Paper Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Printing Services') {
                    subsector = 'Printing Services';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Paints , Varnishes and Lacquers') {
                    subsector = 'Paints , Varnishes and Lacquers';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Soap and Detergents') {
                    subsector = 'Soap and Detergents';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Rubber, Foam and Plastic Products') {
                    subsector = 'Rubber, Foam and Plastic Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Glass and Glass Products') {
                    subsector = 'Glass and Glass Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Cement and Lime') {
                    subsector = 'Cement and Lime';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Pharmaceuticals, Medical Supplies and Equipment') {
                    subsector = 'Pharmaceuticals, Medical Supplies and Equipment';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Cosmetics and Perfumes') {
                    subsector = 'Cosmetics and Perfumes';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Fertilizers') {
                    subsector = 'Fertilizers';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other Chemicals') {
                    subsector = 'Other Chemicals';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Fiber and Fiber Products') {
                    subsector = 'Fiber and Fiber Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Machinery, Equipment and Tools') {
                    subsector = 'Machinery, Equipment and Tools';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Furniture and Fixtures') {
                    subsector = 'Furniture and Fixtures';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Production (Assembly) of Motor Vehicles ,Trailers') {
                    subsector = 'Production (Assembly) of Motor Vehicles ,Trailers';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Tannery') {
                    subsector = 'Tannery';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Bakery') {
                    subsector = 'Bakery';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Garment') {
                    subsector = 'Garment';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other large scale business') {
                    subsector = 'Other large scale business';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other medium scale mfg. business') {
                    subsector = 'Other medium scale mfg. business';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Blacksmith') {
                    subsector = 'Blacksmith';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Pottery') {
                    subsector = 'Pottery';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Weaving') {
                    subsector = 'Weaving';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Tailoring') {
                    subsector = 'Tailoring';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Ornamental and Jewelry') {
                    subsector = 'Ornamental and Jewelry';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Metal Works') {
                    subsector = 'Metal Works';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Bakery and Pastry') {
                    subsector = 'Bakery and Pastry';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Articles of Cement and Lime') {
                    subsector = 'Articles of Cement and Lime';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Sugar Confectionery') {
                    subsector = 'Sugar Confectionery';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other small scale business') {
                    subsector = 'Other small scale business';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Pulses and Oilseeds') {
                    subsector = 'Pulses and Oilseeds';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Vegetables and Fruits') {
                    subsector = 'Vegetables and Fruits';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Forestry products') {
                    subsector = 'Forestry products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Poultry products') {
                    subsector = 'Poultry products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Live animals') {
                    subsector = 'Live animals';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other agricultural products') {
                    subsector = 'Other agricultural products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Sundry and grocery items') {
                    subsector = 'Sundry and grocery items';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Food items (processed)') {
                    subsector = 'Food items (processed)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Chemical and related products') {
                    subsector = 'Chemical and related products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Stationery and Printed Products') {
                    subsector = 'Stationery and Printed Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Cement, Lime and Other Construction Materials') {
                    subsector = 'Cement, Lime and Other Construction Materials';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Iron and Steel') {
                    subsector = 'Iron and Steel';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Articles of Iron') {
                    subsector = 'Articles of Iron';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Ornamental and Jewelry Items') {
                    subsector = 'Ornamental and Jewelry Items';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Leather and Related Products') {
                    subsector = 'Leather and Related Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Textile and Clothing') {
                    subsector = 'Textile and Clothing';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Fiber Products') {
                    subsector = 'Fiber Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Ceramics') {
                    subsector = 'Ceramics';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Carpets and Curtains') {
                    subsector = 'Carpets and Curtains';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Electronics and Electric Appliances') {
                    subsector = 'Electronics and Electric Appliances';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Spare Parts') {
                    subsector = 'Spare Parts';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other domestic trade business') {
                    subsector = 'Other domestic trade business';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Hospitals') {
                    subsector = 'Hospitals';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Clinics') {
                    subsector = 'Clinics';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Laboratory and Related Services') {
                    subsector = 'Laboratory and Related Services';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Others health related business') {
                    subsector = 'Others health related business';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'University and Colleges') {
                    subsector = 'University and Colleges';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Primary and High Schools') {
                    subsector = 'Primary and High Schools';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Pre-Schools') {
                    subsector = 'Pre-Schools';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other education related business') {
                    subsector = 'Other education related business';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Building') {
                    subsector = 'Building';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Warehouse') {
                    subsector = 'Warehouse';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Machinery and equipment') {
                    subsector = 'Machinery and equipment';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Car Rental') {
                    subsector = 'Car Rental';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Fuel Station') {
                    subsector = 'Fuel Station';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Audit Firms and Consultancy Services') {
                    subsector = 'Audit Firms and Consultancy Services';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Commission Agents') {
                    subsector = 'Commission Agents';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Postal and carrier Services') {
                    subsector = 'Postal and carrier Services';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Janitorial, security and related services') {
                    subsector = 'Janitorial, security and related services';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Abattoirs and slaughters') {
                    subsector = 'Abattoirs and slaughters';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Garages') {
                    subsector = 'Garages';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Hotel & tourism') {
                    subsector = 'Hotel & tourism';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Hotels') {
                    subsector = 'Hotels';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Motels, Guest House and pensions') {
                    subsector = 'Motels, Guest House and pensions';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Restaurant, Snacks and Bars') {
                    subsector = 'Restaurant, Snacks and Bars';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Lodges') {
                    subsector = 'Lodges';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Tour and Travel agencies') {
                    subsector = 'Tour and Travel agencies';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Recreation Centers') {
                    subsector = 'Recreation Centers';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Others hotel and tourism service') {
                    subsector = 'Others hotel and tourism service';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Working Capital for contractor') {
                    subsector = 'Working Capital for contractor';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Purchase of construction machineries and dump truck') {
                    subsector = 'Purchase of construction machineries and dump truck';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Sesame') {
                    subsector = 'Sesame';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other oilseeds (excluding sesame)') {
                    subsector = 'Other oilseeds (excluding sesame)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Oilseed Cakes') {
                    subsector = 'Oilseed Cakes';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Frozen Meat') {
                    subsector = 'Frozen Meat';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Fish and related products') {
                    subsector = 'Fish and related products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Hides and Skins') {
                    subsector = 'Hides and Skins';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Raw and Ginned Cotton') {
                    subsector = 'Raw and Ginned Cotton';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Ethanol') {
                    subsector = 'Ethanol';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Honey and Beeswax') {
                    subsector = 'Honey and Beeswax';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Civet') {
                    subsector = 'Civet';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Chat') {
                    subsector = 'Chat';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Leather and Leather Products') {
                    subsector = 'Leather and Leather Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Incense') {
                    subsector = 'Incense';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Gold') {
                    subsector = 'Gold';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Marble') {
                    subsector = 'Marble';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other minerals') {
                    subsector = 'Other minerals';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Wood and related products') {
                    subsector = 'Wood and related products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Cereals, Flour, starch and insulin') {
                    subsector = 'Cereals, Flour, starch and insulin';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Alcohol') {
                    subsector = 'Alcohol';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Manufactured food items') {
                    subsector = 'Manufactured food items';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Aquatic products') {
                    subsector = 'Aquatic products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other food and beverage related business') {
                    subsector = 'Other food and beverage related business';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Yarn and thread') {
                    subsector = 'Yarn and thread';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Woven and textiles') {
                    subsector = 'Woven and textiles';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Readymade clothes') {
                    subsector = 'Readymade clothes';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Carpets and curtain') {
                    subsector = 'Carpets and curtain';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other textile related business') {
                    subsector = 'Other textile related business';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Agricultural commodities') {
                    subsector = 'Agricultural commodities';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Industrial Machinery and parts') {
                    subsector = 'Industrial Machinery and parts';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Construction machinery and parts') {
                    subsector = 'Construction machinery and parts';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Electrical equipment and appliances') {
                    subsector = 'Electrical equipment and appliances';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Telecommunication equipment') {
                    subsector = 'Telecommunication equipment';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Medical and related equipment') {
                    subsector = 'Medical and related equipment';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other imports related to machinery') {
                    subsector = 'Other imports related to machinery';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Bicycles and motor bicycles') {
                    subsector = 'Bicycles and motor bicycles';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Heavy vehicles (Automobiles and mini-buses, etc)') {
                    subsector = 'Heavy vehicles (Automobiles and mini-buses, etc)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Heavy vehicles (Trucks, Mid buses, Buses, etc)') {
                    subsector = 'Heavy vehicles (Trucks, Mid buses, Buses, etc)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other imports related to vehicles') {
                    subsector = 'Other imports related to vehicles';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Salt') {
                    subsector = 'Salt';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Precious metal and stones') {
                    subsector = 'Precious metal and stones';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other imports related to minerals') {
                    subsector = 'Other imports related to minerals';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Petroleum') {
                    subsector = 'Petroleum';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Oil and lubricants') {
                    subsector = 'Oil and lubricants';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Pharmaceutical and related supplies') {
                    subsector = 'Pharmaceutical and related supplies';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Pesticides and insecticides') {
                    subsector = 'Pesticides and insecticides';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Paints and dyeing materials') {
                    subsector = 'Paints and dyeing materials';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Photography and cinematography chemical') {
                    subsector = 'Photography and cinematography chemical';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other chemical products') {
                    subsector = 'Other chemical products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Foam, plastic and related raw materials') {
                    subsector = 'Foam, plastic and related raw materials';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Pulp, paper and paper board') {
                    subsector = 'Pulp, paper and paper board';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Printed books, magazines and newspaper') {
                    subsector = 'Printed books, magazines and newspaper';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Lumber and Related Products') {
                    subsector = 'Lumber and Related Products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other wood products') {
                    subsector = 'Other wood products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Ceramic products, articles of asbestos etc') {
                    subsector = 'Ceramic products, articles of asbestos etc';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Glass and glassware') {
                    subsector = 'Glass and glassware';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other import related to stone, cement, micas') {
                    subsector = 'Other import related to stone, cement, micas';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Copper, Aluminums, Nickel, Zinc') {
                    subsector = 'Copper, Aluminums, Nickel, Zinc';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Articles of base metals') {
                    subsector = 'Articles of base metals';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other base metal products') {
                    subsector = 'Other base metal products';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Oil and Gas') {
                    subsector = 'Oil and Gas';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Quarrying') {
                    subsector = 'Quarrying';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other related to mining business') {
                    subsector = 'Other related to mining business';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Real Estate (Residential Building)') {
                    subsector = 'Real Estate (Residential Building)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Real Estate (Commercial Building)') {
                    subsector = 'Real Estate (Commercial Building)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Dry Cargo') {
                    subsector = 'Dry Cargo';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Fuel Cargo') {
                    subsector = 'Fuel Cargo';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Big Buses(>45 seats)') {
                    subsector = 'Big Buses(>45 seats)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Midi Buses(15-45)') {
                    subsector = 'Midi Buses(15-45)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Mini Buses(15 seats)') {
                    subsector = 'Mini Buses(15 seats)';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Other road transport') {
                    subsector = 'Other road transport';
                    return true;
                }
                else if (subsectorObj?.subsectorName === 'Cargo and Passengers') {
                    subsector = 'Cargo and Passengers';
                    return true;
                }
                else if (subsectorObj?.subsectorName) {
                    // Fallback for any other subsector name not listed above
                    subsector = subsectorObj.subsectorName;
                    return true;
                }
            }
            return false;
        }
    );

    return subsector;
};

export default getSubsector;